import React from 'react';
import Groups from './index';
import ErrorBoundary from '../../../components/ErrorBoundary';
import BackButton from '../../../components/buttons/BackButton';
import HelpButton from '../../../components/HelpButton';

const AdminGroupsEditGroup = React.lazy(() => import('./AdminGroupsEditGroup'));

const AdminGroupsEditGroupPage = (props) => (
  <Groups>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <div className="row mb-2">
          <div className="col text-left">
            <BackButton />
          </div>
          <div className="col text-right">
            <HelpButton fileName="admin-edit-group" />
          </div>
        </div>
        <AdminGroupsEditGroup {...props} />
      </React.Suspense>
    </ErrorBoundary>
  </Groups>
);

export default AdminGroupsEditGroupPage;
